import React, { useState } from 'react';
import { Send } from 'lucide-react';
import { useAuth } from '../../../context/AuthContext';
import { toast } from 'sonner';

interface ConsultantChatInputProps {
  onSendMessage: (message: string) => void;
  isLoading: boolean;
  pricePerMinute: number;
}

export const ConsultantChatInput: React.FC<ConsultantChatInputProps> = ({
  onSendMessage,
  isLoading,
  pricePerMinute
}) => {
  const [message, setMessage] = useState('');
  const { user } = useAuth();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!message.trim() || isLoading) return;

    if (!user) {
      toast.error('Faça login para enviar mensagens');
      return;
    }

    onSendMessage(message);
    setMessage('');
  };

  return (
    <form onSubmit={handleSubmit} className="p-4 border-t border-purple-500/20">
      <div className="flex items-center space-x-2">
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Digite sua mensagem..."
          className="flex-1 bg-white/10 border border-purple-500/20 rounded-lg px-4 py-2 text-purple-200 placeholder-purple-200/50"
          disabled={isLoading}
        />
        <button
          type="submit"
          disabled={isLoading || !message.trim()}
          className="p-2 bg-purple-500 rounded-lg text-white hover:bg-purple-600 transition-colors disabled:opacity-50"
        >
          <Send className="w-5 h-5" />
        </button>
      </div>
      <p className="text-sm text-purple-200/70 mt-2">
        Custo: {pricePerMinute} créditos/minuto
      </p>
    </form>
  );
};